var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var { Heading, Text, Layout } = require('@metro-ui/core');
var defaultMessages = require('../../i18n/messages/default');
var { Button } = require('metro-ui-components');
var AppConstants = require('../../constants/AppConstants')

class ChangeLoginPreferencesComponent extends React.Component {
    changeLoginPreferences() {
        window.location = AppConstants.CHANGE_LOGIN_PREFERNCES.IDENTITY_WORKFLOW_URLS[window.WebConstants.stage];
    }

    render() {
        return (
            <Layout className= "change-login-prefs-container" direction= "column" padding="large">
                <div className= "change-login-prefs-content">
                    <Heading element = "h5" padding="medium">
                    <strong> {this.props.intl.formatMessage(defaultMessages['login.sidebox.2faRequiredForEMP.headline'])}</strong>
                    </Heading>

                    <Text size= "medium">
                        {this.props.intl.formatMessage(defaultMessages['login.sidebox.2faRequiredForEMP.text1'])}
                    </Text>
                    <Text size="medium">
                        {this.props.intl.formatMessage(defaultMessages['login.sidebox.2faRequiredForEMP.text2'])}
                    </Text>

                    <Button isWide
                        size= 'medium'
                        className= "form-controls" 
                        isFullWidth= {false}
                        kind='secondary' 
                        onClick={this.changeLoginPreferences.bind(this)}>
                        {this.props.intl.formatMessage(defaultMessages['login.sidebox.2faRequiredForEMP.chgLoginPrefsButton'])}
                    </Button>
                </div>
            </Layout>
        );
    }
}

module.exports = injectIntl(ChangeLoginPreferencesComponent);